import { render, staticRenderFns } from "./CommodityManage.vue?vue&type=template&id=b246120e&"
import script from "./CommodityManage.vue?vue&type=script&lang=js&"
export * from "./CommodityManage.vue?vue&type=script&lang=js&"
import style0 from "./CommodityManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports